import React from "react";
import "../assets/css/Navbar.css";
import { Link, NavLink } from "react-router-dom";
const Navbar = () => {


  
  return (
    <nav className={`navbar navbar-expand-lg main-header py-4  `}>
      <div className="container main-header-meet">
        <div className="svg-nav-div">
        <Link to='/'>
          <svg
            preserveAspectRatio="xMidYMid meet"
            data-bbox="0 0 218 31"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 218 31"
            height="39"
            width="274"
            data-type="color"
            role="presentation"
            aria-hidden="true"
            aria-label=""
          >
            <g>
              <path
                fill="#2A2C30"
                d="M3.275 4.376q0-1.86-.51-2.735Q2.255.73.728.73H0V0h9.46q3.967 0 6.878 1.313 2.947 1.313 2.947 5.07 0 1.713-1.164 3.1-1.164 1.385-3.566 2.188 3.347.546 4.658 2.006 1.346 1.422 1.346 3.829 0 3.684-2.911 5.142-2.874 1.422-7.096 1.423H3.275zm6.732 6.748q1.491 0 2.801-.548 1.347-.584 2.184-1.677.836-1.131.836-2.699 0-1.641-.982-2.735-.983-1.131-2.51-1.641a8.8 8.8 0 0 0-3.057-.548q-1.274 0-2.73.365v9.483zm0 11.67q3.31 0 5.094-1.313 1.82-1.313 1.82-3.793t-1.784-3.793q-1.746-1.313-5.13-1.313H6.55v9.702q1.746.51 3.457.51"
                data-color="1"
              ></path>
              <path
                fill="#2A2C30"
                d="M28.749 24.435a6.4 6.4 0 0 1-2.365-.474q-1.201-.51-2.075-1.641-.837-1.13-.837-2.99 0-2.772 2.548-3.94 2.583-1.166 6.731-1.167h1.092q0-3.573-.983-4.887-.982-1.312-2.838-1.312-1.637 0-2.62.692-.983.693-1.382 2.408h-1.638q0-1.24.146-1.933.145-.73.764-1.35.654-.656 2.147-.948a15.8 15.8 0 0 1 3.31-.328q2.948 0 4.659 1.604 1.71 1.569 1.71 6.054v9.848h-1.82l-1.273-1.642h-.182q-.655.84-1.929 1.423t-3.165.583m1.637-1.64q1.2 0 2.001-.584.802-.584 1.456-1.605v-4.924H32.75q-2.693 0-4.257 1.021-1.565.985-1.565 2.626 0 1.678.983 2.59 1.019.875 2.474.875"
                data-color="1"
              ></path>
              <path
                fill="#2A2C30"
                d="M49.215 24.435q-2.62 0-4.44-1.167a7.56 7.56 0 0 1-2.692-3.21q-.874-2.04-.874-4.558t.874-4.522q.91-2.043 2.692-3.21 1.82-1.203 4.44-1.203 4.002 0 5.276 1.276.618.62.764 1.532.145.875.145 3.21h-.727q-.145-2.262-1.42-3.392-1.273-1.167-3.31-1.167-2.621 0-3.967 2.078-1.31 2.079-1.31 5.398t1.31 5.398q1.347 2.079 3.966 2.079 1.855 0 3.057-.694 1.2-.729 2.22-2.224l.727.547q-1.2 2.042-2.838 2.954-1.638.875-3.893.875"
                data-color="1"
              ></path>
              <path
                fill="#2A2C30"
                d="M72.699 24.435q-3.093 0-5.276-2.917l-4.367-5.836v8.389h-3.275V4.376q0-1.86-.509-2.735-.51-.912-2.038-.912h-.727V0h3.274q1.347 0 2.002.365.69.328.982 1.24.291.911.291 2.771v10.76L67.605 9.3q.946-1.168 2.001-1.75 1.055-.62 2.73-.62h1.09v.911a4.6 4.6 0 0 0-1.891.401 4.04 4.04 0 0 0-1.565 1.24l-4.003 5.106 4.549 5.836q1.055 1.385 1.965 2.078.946.693 2.037.876v.693q-.8.364-1.819.364"
                data-color="1"
              ></path>
              <path
                fill="#2A2C30"
                d="M83.664 24.435q-2.728 0-4.475-1.458-1.71-1.46-1.71-5.106v-6.565q0-1.86-.51-2.735-.51-.912-2.038-.912h-.364v-.73h2.912q1.346 0 2 .365.693.328.983 1.24t.291 2.772v6.565q0 2.553 1.128 3.756 1.165 1.167 2.875 1.167 1.929 0 3.639-1.933V6.93h3.275v17.142h-1.82l-1.273-1.46h-.182q-.765.767-2.001 1.314-1.2.51-2.73.51"
                data-color="1"
              ></path>
              <path
                fill="#2A2C30"
                d="M97.46 11.306q0-1.86-.508-2.735-.51-.912-2.038-.912h-.728v-.73h3.275q1.383 0 2.074.402.728.364 1.019 1.24h.182q.654-.84 1.856-1.423 1.2-.583 3.056-.583 3.129 0 4.84 2.553 1.71 2.516 1.71 6.382 0 3.903-1.783 6.419-1.747 2.516-5.131 2.516-1.382 0-2.438-.291a12.5 12.5 0 0 1-2.11-.803V31h-3.275zm6.733 11.67q2.328 0 3.42-2.042 1.128-2.042 1.128-5.434 0-3.355-1.055-5.398-1.056-2.078-3.13-2.078-2.437 0-3.82 2.188v11.67a24 24 0 0 0 1.892.803 4.6 4.6 0 0 0 1.565.292"
                data-color="1"
              ></path>
              <path
                fill="#71C55D"
                d="M144.228 25.712q-2.62 0-4.076-.803-1.455-.801-2.074-2.48-.582-1.713-.582-4.558V3.829l-9.097 20.242h-.727l-9.461-20.606V24.07h-1.456V0h3.457l8.733 18.965L137.496 0h3.275v17.87q0 3.393.837 5.252.873 1.86 2.62 1.86z"
                data-color="2"
              ></path>
              <path
                fill="#71C55D"
                d="M153.429 24.435q-2.474 0-4.184-1.167-1.711-1.203-2.584-3.21-.873-2.04-.873-4.558 0-2.48.873-4.522t2.511-3.21q1.674-1.203 3.893-1.203 3.675 0 5.458 2.079 1.82 2.042 1.82 5.944l-.073 1.46h-11.025q0 3.062 1.309 4.996 1.311 1.932 3.603 1.933 1.71 0 2.874-.73 1.202-.73 2.22-2.188l.728.547q-1.202 2.006-2.802 2.917-1.601.912-3.748.912m3.457-9.847q0-3.21-.946-4.887t-2.875-1.677q-1.092 0-1.965.875-.873.838-1.382 2.334-.474 1.495-.473 3.355z"
                data-color="2"
              ></path>
              <path
                fill="#71C55D"
                d="M164.829 11.306q0-1.86-.51-2.735-.509-.912-2.038-.912h-.363v-.73h2.911q1.382 0 2.074.402.727.364 1.019 1.24h.181q.655-.84 1.747-1.423 1.128-.583 2.62-.583 1.455 0 2.183.547.619.474 1.274 1.64l-1.456 1.095q-.4-.547-1.164-.802-.765-.292-1.747-.292-1.091 0-2.001.51a3.8 3.8 0 0 0-1.456 1.313v13.495h-3.274z"
                data-color="2"
              ></path>
              <path
                fill="#71C55D"
                d="M183.075 24.435q-1.164 0-2.365-.474-1.2-.51-2.074-1.641-.837-1.13-.837-2.99 0-2.772 2.547-3.94 2.585-1.166 6.732-1.167h1.092q0-3.573-.983-4.887-.983-1.312-2.838-1.312-1.638 0-2.62.692-.983.693-1.383 2.408h-1.637q0-1.24.146-1.933.145-.73.764-1.35.654-.656 2.147-.948a15.8 15.8 0 0 1 3.311-.328q2.947 0 4.657 1.604 1.71 1.569 1.711 6.054v9.848h-1.82l-1.273-1.642h-.182q-.655.84-1.929 1.423-1.273.583-3.166.583m1.638-1.64q1.2 0 2.001-.584t1.456-1.605v-4.924h-1.092q-2.692 0-4.257 1.021-1.565.985-1.565 2.626 0 1.678.983 2.59 1.019.875 2.474.875"
                data-color="2"
              ></path>
              <path
                fill="#71C55D"
                d="M209.436 24.435q-3.093 0-5.276-2.917l-4.367-5.836v8.389h-3.274V4.376q0-1.86-.51-2.735-.51-.912-2.037-.912h-.728V0h3.275q1.346 0 2.001.365.691.328.982 1.24t.291 2.771v10.76l4.549-5.836q.947-1.168 2.001-1.75 1.055-.62 2.729-.62h1.092v.911q-.983 0-1.892.401a4.04 4.04 0 0 0-1.565 1.24l-4.003 5.106 4.549 5.836q1.055 1.385 1.965 2.078.946.693 2.038.876v.693q-.801.364-1.82.364"
                data-color="2"
              ></path>
              <path
                fill="#71C55D"
                d="M216.108 4.741q-.837 0-1.456-.693a2.47 2.47 0 0 1-.582-1.64q0-.768.437-1.204.473-.438 1.237-.438.837 0 1.419.693.618.693.619 1.641 0 .766-.473 1.204-.437.437-1.201.437m-1.383 6.565q0-1.86-.509-2.735-.51-.912-2.038-.912h-.728v-.73h3.275q1.347 0 2.001.365.692.328.983 1.24t.291 2.772V24.07h-3.275z"
                data-color="2"
              ></path>
            </g>
          </svg>
          </Link>
        </div>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent" >
          <ul className="navbar-nav me-auto mb-2 mb-lg-0 ">
          <li className="nav-item dropdown product-list-dropdown">
              <Link
                className="nav-link dropdown-toggle"
                to="#"
                id="productDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Product
              </Link>
              <ul className="dropdown-menu faq-main-ul" aria-labelledby="productDropdown">
                <li>
                  <Link className="dropdown-item-faq" to="/faq">
                    FAQ
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item-faq" to="/pricing">
                    Pricing
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item-faq" to="/release-notes">
                    Release Notes
                  </Link>
                </li>
              </ul>
          </li>
          
          <NavLink to="/how-it-works" className={({ isActive }) => isActive ? "nav-link active-link" : "nav-link"}>How it works</NavLink>
          <NavLink to='/security' className={({ isActive }) => isActive ? "nav-link active-link" : "nav-link"}> <li className="security-li">Security</li></NavLink>
          <NavLink to='/about-us' className={({ isActive }) => isActive ? "nav-link active-link" : "nav-link"}><li className="about-us-li">About Us</li></NavLink>
           
          </ul>
          <div className="nav-inside-mobile d-block d-lg-none">
          <button
            className="btn py-3 px-5 fw-bold login-btn"
            type="button"
            onClick={() =>
              window.open("https://app.backupmeraki.com/login", "_blank")
            }
          >
            <i className="bi bi-person-fill me-2"></i>
          <span className="login-btn-span">  Log In </span>
          </button>

          <button
            className="btn main-btn"
            type="button"
            onClick={() =>
              window.open("https://app.backupmeraki.com/register", "_blank")
            }
          >
            Sign Up
          </button>
        </div>
        </div>
        <div className="header-btn d-none d-lg-block">
          <button
            className="btn py-3 px-5 fw-bold login-btn"
            type="button"
            onClick={() =>
              window.open("https://app.backupmeraki.com/login", "_blank")
            }
          >
            <i className="bi bi-person-fill me-2"></i>
          <span className="login-btn-span">  Log In </span>
          </button>

          <button
            className="btn main-btn"
            type="button"
            onClick={() =>
              window.open("https://app.backupmeraki.com/register", "_blank")
            }
          >
            Sign Up
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
